
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";

import * as api from "../constant/API";
import { Link } from "react-router-dom";
import Utils from "../constant/Utils";
import Swal from "sweetalert2";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";

const Class = () => {
    const [searchInput, setSearchInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [instituteId, setInstituteId] = useState("");
    const [addClsInstituteId, setAddClsInstituteId] = useState("");
    const [addClsName, setAddClsName] = useState("");
    const [instituteList, setInstituteList] = useState([]);
    const [clas, setClas] = useState([]);
    const [clsId, setClsId] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false)

    const userId = localStorage.getItem('UserId');
    const roleId = localStorage.getItem('RoleId');

    useEffect(() => {
        const instList = api.InstDd + '/' + roleId;
        setIsLoading(true);
        setTimeout(() => {
            fetch(instList, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    setInstituteList(result.data);
                    setIsLoading(false);
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setIsLoading(false);
                });
        }, 1000);
    }, []);

    function listClasses(insId) {
        setInstituteId(insId);
        setIsLoading(true);
        setTimeout(() => {
            const getClassList = api.Class + '/' + insId;
            fetch(getClassList, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    setClas(result.data);
                    setIsLoading(false);
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setIsLoading(false);
                })
        }, 1000);
    }

    function editClass(rowData) {
        const clsId = rowData.classId;
        setClsId(clsId);
        setIsEdit(true)
        setOpenModal(true)
        fetchDetails()
    }

    function fetchDetails() {
        const editCls = api.Class + '/' + instituteId + '/' + clsId;
        fetch(editCls, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setAddClsName(result.data[0].className)
                } else {
                    Swal.fire(result.message)
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
    }

    function archiveClass(rowData) {
        const clsId = rowData.classId;
        const removeCls = api.ArchieveClass + '/' + clsId + '/' + instituteId;
        fetch(removeCls, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire(result.message)
                } else {
                    Swal.fire(result.message)
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
    }

    function saveClass() {
        if (isEdit) {
            updateClass()
        } else {
            const formData = new FormData();
            formData.append("classInstitution", addClsInstituteId)
            formData.append("className", addClsName)

            const createClass = api.ClassCreate;
            fetch(createClass, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    }
                })
        }
        setOpenModal(false)
    }

    function updateClass() {
        const formData = new FormData();
        formData.append('classIdEdit', clsId);
        formData.append('classInstitutionEdit', instituteId)
        formData.append('classNameEdit', addClsName)
        const classUpdate = api.ClassUpdate;
        fetch(classUpdate, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    const filteredData = clas.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const classRender = (rowData) => {
        return <span>{rowData.className}</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editClass(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const removeClass = (rowData) => {
        return (
            <Link to="#" onClick={() => archiveClass(rowData)}>
                <i className="feather-edit"></i>Remove
            </Link>
        );
    };

    return (
        <>

            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="row">
                <div className="col-sm-12">
                    <div className="court-tab-content">
                        <div className="card card-tableset">
                            <div className="card-body">
                                <div className="coache-head-blk">
                                    <div className="row align-items-center">
                                        <div className="row col-md-6 court-sortby sortbyset">
                                            <div className="col-md-2" style={{ marginTop: "1.25rem" }}>
                                                <span className="sortbytitle"><h6>Institute</h6></span>
                                            </div>
                                            <div className="col-md-10 sorting-select">
                                                <Select
                                                    value={instituteList.find(ins => ins.institutionId === instituteId) ? {
                                                        value: instituteId,
                                                        label: instituteList.find(ins => ins.institutionId === instituteId).institutionName
                                                    } : null}
                                                    onChange={(e) => {
                                                        listClasses(e.value)
                                                    }}
                                                    options={instituteList.map(ins => ({
                                                        value: ins.institutionId,
                                                        label: ins.institutionName
                                                    }))}>
                                                </Select>
                                            </div>
                                        </div>
                                        {(roleId == '1' || roleId == '5') ? (
                                            <>
                                                <div className="row col-md-6">
                                                    <div className="save-changes text-sm-end">
                                                        <Button
                                                            className="btn-secondary text-uppercase"
                                                            variant="success"
                                                            onClick={() => { setOpenModal(true); setIsEdit(false) }}
                                                        >
                                                            <i className="fas fa-plus">Add Class</i>
                                                        </Button>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div className="col-md-12">
                                        </div>
                                        <div className="col-md-12">
                                        </div>
                                        <div className="col-md-6">
                                        </div>
                                        <div className="col-md-6">
                                            <div className="dataTables_filter">
                                                <label>
                                                    <input
                                                        type="text"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                        className="form-control"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                currentPageReportTemplate="{first}"
                                                pageLinkSize={3}
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slNo"
                                                    body={slNoRender}
                                                    header="Sl No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="className"
                                                    header="Class Name"
                                                    body={classRender}
                                                ></Column>
                                                {(roleId == '1'|| roleId == '5') ? (
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    ></Column>
                                                ) : null}
                                                {(roleId == '1'|| roleId == '5') ? (
                                                    <Column
                                                        className="text-link"
                                                        body={removeClass}
                                                    ></Column>
                                                ) : null}

                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                openModal && (
                    <Modal
                        show={openModal}
                        size="sm"
                        centered
                    >
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case">{isEdit ? "Edit Section" : "Add Section"}</h4>
                            </ModalTitle>
                            <Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)}
                            ></Button>
                        </ModalHeader>
                        <ModalBody>
                            {!isEdit &&
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Institute</label>
                                        <Select
                                            value={instituteList.find(ins => ins.institutionId === addClsInstituteId) ? {
                                                value: addClsInstituteId,
                                                label: instituteList.find(ins => ins.institutionId === addClsInstituteId).institutionName
                                            } : null}
                                            onChange={(e) => {
                                                setAddClsInstituteId(e?.value)
                                            }}
                                            options={instituteList.map(ins => ({
                                                value: ins.institutionId,
                                                label: ins.institutionName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                            }
                            <div className="col-lg-12 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Class</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        id="class"
                                        value={addClsName}
                                        onChange={(e) => setAddClsName(e.target.value)}
                                        placeholder="Class Name" />
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                onClick={() => { saveClass(); setOpenModal(false) }}
                                data-bs-dismiss="modal" aria-label="Close"
                            >
                                <b><i className="fas fa-save" />Save</b>
                            </Button>
                        </ModalFooter>
                    </Modal>
                )
            }
        </>
    );
};

export default Class;
